import { useDisclosure } from '@chakra-ui/react'
import { createContext, useState } from 'react'

const IssueReporterContext = createContext()

const IssueReporterProvider = ({ children }) => {
    const {
        isOpen: isReporterOpen,
        onOpen: onReporterOpen,
        onClose: onReporterClose,
    } = useDisclosure()
    const [squad , setSquad] = useState(null);

    const updateSquad = (squadNumber) => {
        setSquad(squadNumber);
    }

    return (
        <IssueReporterContext.Provider
            value={{
                isReporterOpen,
                onReporterOpen,
                onReporterClose,
                updateSquad,
                squad
            }}
        >
            {children}
        </IssueReporterContext.Provider>
    )
}

export default IssueReporterContext
export { IssueReporterProvider }
